import Vue from 'vue'
import Router from 'vue-router'
import HelloWorld from '@/components/HelloWorld'
import Index from '@/components/Index'
import AddApplication from '@/components/AddApplication'
import ShopInfo from '@/components/ShopInfo'
import User from '@/components/User'
import EditApp from '@/components/EditApp'
import Plugin from '@/components/Plugin'
import Template from '@/components/Template'
import Extend from '@/components/Extend'
import Result from '@/components/Result'
import Chengxu from '@/components/Chengxu'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'Index',
      component: Index
    },
      {
          path: '/index',
          name: 'Index',
          component: Index
      }
      ,
      {
          path: '/addapplication',
          name: 'AddApplication',
          component: AddApplication
      }
      ,
      {
          path: '/shopinfo',
          name: 'ShopInfo',
          component: ShopInfo
      },
      {
          path: '/user',
          name: 'User',
          component: User
      },
      {
          path: '/editapp',
          name: 'EditApp',
          component: EditApp
      },
      {
          path: '/plugin',
          name: 'Plugin',
          component: Plugin
      }
      ,
      {
          path: '/template',
          name: 'Template',
          component: Template
      }
      ,
      {
          path: '/extend',
          name: 'Extend',
          component: Extend
      }
      ,
      {
          path: '/result',
          name: 'Result',
          component: Result
      } ,
      {
          path: '/chengxu',
          name: 'Chengxu',
          component: Chengxu
      }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js